export default "__VITE_ASSET__BYdjsZXe__"